// dependencies
import { FadeIn } from "react-slide-fade-in";

// styling
import "./Home.css";

// images/icons
import CameronMontesano from "./resources/images/team-photos/CameronMontesano.jpg";
import JessieGardner from "./resources/images/team-photos/JessieGardner.jpg";
import AidanSullivan from "./resources/images/team-photos/AidanSullivan.jpg";
import MilesBrown from "./resources/images/team-photos/MilesBrown.jpg";
import ReganKalvelage from "./resources/images/team-photos/ReganKalvelage.jpg";
import VictorLeshyk from "./resources/images/team-photos/VictorLeshyk.jpg";
import BlankProfilePhoto from "./resources/images/team-photos/blank-profile-photo.webp";

const teamMembers = [
  {
    name: "Cameron Montesano",
    roles: ["Team Lead", "Release Manager"],
    image: CameronMontesano,
  },
  {
    name: "Jessie Gardner",
    roles: ["Release Manager"],
    image: JessieGardner,
  },
  {
    name: "Miles Brown",
    roles: ["SME", "UI Design Lead"],
    image: MilesBrown,
  },
  {
    name: "Regan Kalvelage",
    roles: ["Code Lead"],
    image: ReganKalvelage,
  },
  {
    name: "Aidan Sullivan",
    roles: ["SME", "Code Lead"],
    image: AidanSullivan,
  },
];

export default function Home() {
  return (
    <div className="home-page">
      <div className="banner">
        <div className="content-wrapper">
          <FadeIn
            from="bottom"
            positionOffset={100}
            triggeroffset={0}
            delayInMilliseconds={0}>
            <h1>Welcome!</h1>
            <p>
              We are team ZMotion. Our task is to create a plugin for ZBrush
              that will enable creators to effortlessly make animations with
              their own models! Check out this video for more information.
            </p>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/vqj0iTeV7co"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen></iframe>
          </FadeIn>
        </div>
      </div>
      <div className="team-info">
        <FadeIn
          from="bottom"
          positionOffset={100}
          triggeroffset={0}
          delayInMilliseconds={0}>
          <div className="sponsor-mentor">
            <div>
              <h2>Sponsor</h2>
              <div className="card">
                <img
                  alt="Victor Leshkyk"
                  src={VictorLeshyk}
                  draggable="false"
                  loading="lazy"
                />
                <div className="details">
                  <span className="name">Professor Victor O. Leshyk</span>
                  <span className="role">
                    Director, Science & Art, Center for Ecosystem Science and
                    Society, NAU
                  </span>
                </div>
              </div>
            </div>
            <div>
              <h2>Mentor</h2>
              <div className="card">
                <img
                  alt="Rudhira Talla"
                  src={BlankProfilePhoto}
                  draggable="false"
                  loading="lazy"
                />
                <div className="details">
                  <span className="name">Rudhira Talla</span>
                  <span className="role">Capstone Mentor</span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn
          from="bottom"
          positionOffset={100}
          triggeroffset={0}
          delayInMilliseconds={0}>
          <div className="team">
            <h2>The Team</h2>
            <div className="team-member-list">
              {teamMembers.map((member) => {
                return (
                  <div className="card box">
                    <img
                      alt={member.name}
                      src={member.image}
                      draggable="false"
                      loading="lazy"
                    />
                    <div className="details">
                      <span className="name">{member.name}</span>
                      {member.roles.map((role) => {
                        return <span className="role">{role}</span>;
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}
